import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

const STORAGE_KEY = "activityWhatsNewBannerDismissed";
const BANNER_VERSION = "v1";

const readDismissedVersion = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const persistDismissedVersion = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, BANNER_VERSION);
  } catch {
    // Ignore quota / private-mode failures; the banner still closes for this visit.
  }
};

const ActivityWhatsNewBanner = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(
    () => readDismissedVersion() === BANNER_VERSION,
  );

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    persistDismissedVersion();
    setDismissed(true);
  };

  return (
    <div className="activity-whats-new" role="status">
      <button
        type="button"
        className="activity-whats-new__close"
        onClick={handleDismiss}
        aria-label={t("Close")}
      >
        <i className="fas fa-times" aria-hidden />
      </button>
      <div className="activity-whats-new__icon" aria-hidden>
        <i className="fas fa-info-circle" />
      </div>
      <div className="activity-whats-new__content">
        <h2 className="activity-whats-new__title">
          {t("activityWhatsNew.title")}
        </h2>
        <p className="activity-whats-new__text">
          {t("activityWhatsNew.intro")}
        </p>
        <p className="activity-whats-new__text">
          <Trans
            i18nKey="activityWhatsNew.hint"
            components={{
              dots: (
                <i
                  className="fas fa-ellipsis-v activity-whats-new__dots"
                  aria-hidden
                />
              ),
              detail: <strong />,
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default ActivityWhatsNewBanner;
